import axios from "axios";
import store from "@/store/index";
import cleanParams from "./cleanParams";

const URL = window.location;
const CSRF_META = document.querySelector('meta[name="csrf-token"]');

const axiosV1 = axios.create({
	baseURL: `${URL.protocol}//${URL.hostname}/v1/`,
});

axiosV1.interceptors.request.use(
	async (config) => {
		const token = localStorage.getItem("auth_token");

		const data = {
			...config,
			headers: {
				...config.headers,
        Authorization: config.headers.Authorization || `Bearer ${token}`,
        'X-CSRF-TOKEN': CSRF_META?.getAttribute('content'),
			},
			params: cleanParams(config.params),
    }
    // console.debug('[request]', data)
		return data;
	},
	(error) => {
    console.warn('error');
		Promise.reject(error);
	}
);

axiosV1.interceptors.response.use(
	function (response) {
		store.commit("alert/setAutoClose", false);
		store.commit("alert/setAutoClose", true);
		return response;
	},
	function (error) {
		store.commit("alert/setAutoClose", false);
		if (error.response && ![200,202].includes(error.response.status)) {
			const responseMessage = error?.response?.data?.message;
			const responseError = error?.response?.data?.error;

			/**
			 * Reset b-alert message
			 * Bug Fix - CRA-915
			 */
			// store.commit("alert/error", "");
			/* end */

			if (responseMessage) {
				store.commit("alert/error", responseMessage);
			} else if (responseError) {
				store.commit("alert/error", responseError);
			} else {
				console.warn(error);
			}
		}
		store.commit("alert/setAutoClose", true);
		return Promise.reject(error);
	}
);

export default axiosV1;
